// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"fde55452","2781":"fde55452","3732":"fde55452","6082":"f4707c62","6978":"8b4dc568"}[chunkId] + ".chunk.css";
};